import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-brand-border bg-brand-soft/40">
      <div className="container-hs py-12 grid gap-8 md:grid-cols-3 text-sm text-brand-muted">
        <div>
          {/* Text wordmark used pending delivery of Home Cost Path logo artwork. */}
          <div className="font-display text-2xl font-semibold text-brand-ink tracking-tight mb-3">
            Home<span className="text-brand-accent">CostPath</span>
          </div>
          <p>See the real cost before you buy.</p>
        </div>
        <div className="md:col-span-2">
          <p className="leading-relaxed">
            Home Cost Path is an independent educational planning tool provided by TaskHive LLC.
            Home Cost Path does not provide mortgage lending, brokerage, underwriting, appraisal,
            real-estate brokerage, legal, tax, or financial-advisory services. Estimates are
            for planning purposes only and are not loan offers, approvals, appraisals, or
            guarantees. Actual eligibility, loan terms, closing costs, property requirements,
            and settlement amounts must be confirmed with qualified professionals. Home Cost Path
            is not affiliated with or endorsed by the U.S. Department of Veterans Affairs or
            any other government agency.
          </p>
          <nav data-testid="footer-legal" className="mt-4 flex flex-wrap gap-x-4 gap-y-2 text-xs">
            <Link to="/privacy" className="hover:text-brand-ink underline">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-brand-ink underline">Terms of Use</Link>
            <Link to="/cookies" className="hover:text-brand-ink underline">Cookie &amp; Analytics Notice</Link>
            <Link to="/refund" className="hover:text-brand-ink underline">Refund Policy</Link>
            <Link to="/contact" className="hover:text-brand-ink underline">Contact &amp; Support</Link>
          </nav>
          <p className="mt-4">© 2026 TaskHive LLC. Home Cost Path is a product of TaskHive LLC.</p>
        </div>
      </div>
    </footer>
  );
}
